<template>
  <div class="layout">
    <div class="layout__header">
      <div v-if="pedido != null" class="layout__title">
        <h3>Venta {{ pedido.numero_documento }}</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <label v-show="cliente == null" for="verAuditoria">
            <input type="checkbox" name="verAuditoria" id="verAuditoria" v-model="verAuditoria"><span>Ver auditoría</span>
          </label>
          <button
            v-show="pedido != null && !editMode"
            type="button"
            @click="$modal.show('editarCoordenadas')"
            class="btn-info btn--text"
          >
            <i class="fa fa-map-marker"></i><span>Editar coordenadas</span>
          </button>
          <button
            type="button"
            @click="verGaleria"
            class="btn-secondary btn--text"
          >
            <i class="fa fa-picture-o"></i><span>Galería</span>
          </button>
          <button
            v-show="cliente == null"
            type="button"
            @click="verComentarios"
            class="btn-warning btn--text"
          >
            <i class="fa fa-comment"></i><span>Comentarios</span>
          </button>
          <button
            v-if="pedido != null"
            v-show="!editMode && puedeEditarPedido && pedido.estado !== 'A'"
            @click="editar"
            class="btn-primary btn--text"
          >
            <i class="fa fa-edit"></i><span>Editar</span>
          </button>
          <button
            v-if="pedido != null"
            v-show="!editMode && puedeEditarPedido && pedido.estado !== 'A'"
            @click="editarAbonos"
            class="btn-success btn--text"
          >
            <i class="fa fa-money"></i><span>Abonos</span>
          </button>
          <button v-show="cliente == null" type="button" @click="imprimir" class="btn-info btn--text">
            <i class="fa fa-print"></i><span>Imprimir</span>
          </button>
          <button type="button" @click="imprimirKardex" class="btn-danger btn--text">
            <i class="fa fa-print"></i><span>Kardex</span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="pedido != null" class="row">
      <div class="col-xs-12">
        <div class="table-responsive">
          <table>
            <tbody>
              <tr>
                <td width="25%"><strong>Fecha de venta:</strong></td>
                <td>
                  <span v-if="!editMode">
                    {{ pedido.fecha }}
                  </span>
                  <div v-else class="form-field">
                    <div class="datepicker-field">
                      <VueCtkDateTimePicker
                        id="desde"
                        v-model="form.fecha"
                        locale="es"
                        no-label
                        button-now-translation="Ahora"
                        format="YYYY-MM-DD HH:mm"
                        formatted="YYYY-MM-DD HH:mm"
                        label="Seleccione fecha..."
                      />
                      <span
                        v-if="errores.fecha"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.fecha[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </td>
                <td width="25%"><strong>Día de cobro</strong></td>
                <td>
                  <div class="form-field select">
                    <div class="select-field">
                      <select
                        :disabled="!editMode"
                        id="dia_cobro"
                        v-model="form.dia_cobro"
                      >
                        <option disabled value="">Seleccione...</option>
                        <option value="1">Lunes</option>
                        <option value="2">Martes</option>
                        <option value="3">Miércoles</option>
                        <option value="4">Jueves</option>
                        <option value="5">Viernes</option>
                        <option value="6">Sábado</option>
                        <option value="7">Domingo</option>
                      </select>
                      <span
                        v-if="errores.dia_cobro"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.dia_cobro[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>Vendedor:</strong></td>
                <td>
                  <span v-if="!editMode">
                    {{ pedido.vendedor.descripcion }}
                  </span>
                  <div class="form-field select2" v-else>
                    <div class="select2-field">
                      <v-select
                        @search="onSearchVendedores"
                        id="vendedorPedido"
                        v-model="selectedVendedor"
                        @input="inputVendedor"
                        placeholder="Seleccione..."
                        :options="vendedores"
                        label="descripcion"
                      ></v-select>
                      <span
                        v-if="errores.vendedor_id"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.vendedor_id[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </td>
                <td><strong>Cliente:</strong></td>
                <td>
                  <span v-if="!editMode">
                    {{ pedido.cliente.descripcion }}
                    <button @click="verInfoCliente" type="button" class="btn-info btn--text"><i class="fa fa-info"></i></button>
                  </span>
                  <div class="form-field select2" v-else>
                    <div class="select2-field">
                      <v-select
                        @search="onSearchClientes"
                        id="clientePedido"
                        v-model="selectedCliente"
                        @input="inputCliente"
                        placeholder="Seleccione..."
                        :options="clientes"
                        label="descripcion"
                      ></v-select>
                      <span
                        v-if="errores.cliente_id"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.cliente_id[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Dirección del cliente:</strong>
                </td>
                <td>
                  <button v-if="pedido.cliente.coordenadas_cliente != null" @dblclick="verDireccionCliente" type="button" class="btn-info btn--text">
                    {{ pedido.cliente.direccion }}
                  </button>
                  <span v-else>
                    {{ pedido.cliente.direccion }}
                  </span>
                </td>
                <td>
                  <strong>Dirección de la venta:</strong>
                </td>
                <td>
                  <button v-show="pedido.direccion_venta != null && pedido.direccion_venta != ''" @dblclick="verDireccionVenta" type="button" class="btn-info btn--text">
                    {{ pedido.direccion_venta }}
                  </button>
                </td>
              </tr>
              <tr>
                <td v-show="verAuditoria"><strong>Observación:</strong></td>
                <td v-show="verAuditoria">
                  <span v-if="!editMode">
                    {{ pedido.observacion }}
                  </span>
                  <div v-else class="form-field">
                    <textarea-field
                      placeholder="Escriba una observación..."
                      id="observacion"
                      v-model="form.observacion"
                    >
                      <span
                        v-if="errores.observacion"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.observacion[0] }}</strong>
                      </span>
                    </textarea-field>
                  </div>
                </td>
                <td><strong>Observación de modificación:</strong></td>
                <td :colspan="verAuditoria?1:3">
                  <span v-if="!editMode">
                    {{ pedido.observacion_modificacion }}
                  </span>
                  <div v-else class="form-field">
                    <textarea-field
                      placeholder="Escriba una observación de modificación..."
                      id="observacion_modificacion"
                      v-model="form.observacion_modificacion"
                    >
                      <span
                        v-if="errores.observacion_modificacion"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{
                          errores.observacion_modificacion[0]
                        }}</strong>
                      </span>
                    </textarea-field>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>Ruta:</strong></td>
                <td>
                  <span v-if="!editMode">
                    {{
                      pedido.ruta != null
                        ? pedido.ruta.descripcion
                        : pedido.visita.ruta.descripcion
                    }}
                  </span>
                  <div v-else class="form-field select2">
                    <div class="select2-field">
                      <v-select
                        @input="inputRuta"
                        id="ruta_id"
                        v-model="selectedRuta"
                        :options="rutas"
                        @search="onSearchRutas"
                        label="descripcion"
                      ></v-select>
                    </div>
                  </div>
                </td>
                <td><strong>Supervisor:</strong></td>
                <td>
                  <span v-if="!editMode">
                    {{ pedido.supervisor.descripcion }}
                  </span>
                  <div v-else class="form-field select2">
                    <div class="select2-field">
                      <v-select
                        placeholder="Seleccione..."
                        :options="supervisores"
                        id="supervisor"
                        name="supervisor"
                        @input="inputSupervisor"
                        v-model="selectedSupervisor"
                        @search="searchSupervisores"
                        label="nombre"
                      ></v-select>
                      <span
                        v-if="errores.supervisor_id"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.supervisor_id[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>Verificador:</strong></td>
                <td>
                  <span v-if="!editMode">
                    {{ pedido.verificador != null?pedido.verificador.descripcion:'' }}
                  </span>
                  <div v-else class="form-field select2">
                    <div class="select2-field">
                      <v-select
                        placeholder="Seleccione..."
                        :options="verificadores"
                        id="verificador"
                        name="verificador"
                        @input="inputVerificador"
                        v-model="selectedVerificador"
                        @search="searchVerificadores"
                        label="descripcion"
                      ></v-select>
                      <span
                        v-if="errores.verificador_id"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.verificador_id[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </td>
                <td><strong>Recaudador:</strong></td>
                <td>
                  <span v-if="!editMode">
                    {{ pedido.recaudador.descripcion }}
                  </span>
                  <div v-else class="form-field select2">
                    <div class="select2-field">
                      <v-select
                        placeholder="Seleccione..."
                        :options="recaudadores"
                        id="recaudador"
                        name="recaudador"
                        @input="inputRecaudador"
                        v-model="selectedRecaudador"
                        @search="searchRecaudadores"
                        label="nombre"
                      ></v-select>
                      <span
                        v-if="errores.recaudador_id"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.recaudador_id[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-show="verAuditoria">
                <td><strong>Creación</strong></td>
                <td v-if="pedido.creador != null">
                  {{ pedido.created_at }} ({{ pedido.creador.nombre_usuario }})
                </td>
                <td v-else></td>
                <td><strong>Modificación</strong></td>
                <td v-if="pedido.modificador != null">
                  {{ pedido.updated_at }} ({{
                    pedido.modificador.nombre_usuario
                  }})
                </td>
                <td v-else></td>
              </tr>
              <tr v-show="verAuditoria">
                <td><strong>Últ. Cambio Estado</strong></td>
                <td>
                  {{ pedido.fecha_cambio_estado }}
                </td>
                <td><strong>Supervisor de cambio</strong></td>
                <td v-if="pedido.supervisor_cambio != null">
                  {{ pedido.supervisor_cambio.nombre_usuario }}
                </td>
                <td v-else></td>
              </tr>
              <!-- <tr>
                <td><strong>Premio</strong></td>
                <td colspan="3">
                  <span v-if="!editMode">
                    {{ pedido.tiene_premio ? "Sí" : "No" }}
                  </span>
                  <p  v-else>
                    <div class="form-field">
                      <label for="tiene_premio">
                        <input
                          type="checkbox"
                          name="tiene_premio"
                          id="tiene_premio"
                          v-model="form.tiene_premio"
                        /><span></span>
                      </label>
                    </div>
                  </p>
                </td>
              </tr> -->
              <tr>
                <td>
                  <strong>Estado</strong>
                </td>
                <td>
                  <span v-if="!editMode">
                    {{ pedido.descripcion_estado }}
                  </span>
                  <div v-else class="form-field select">
                    <div class="select-field">
                      <select name="estado" v-model="form.estado" id="estado">
                        <option value="P">Pendiente</option>
                        <option value="I">Incobrable</option>
                        <option value="F">Finalizado</option>
                      </select>
                      <span
                        v-if="errores.estado"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.estado[0] }}</strong>
                      </span>
                    </div>
                  </div>
                </td>
                <td>
                  <strong>Estado de pago</strong>
                </td>
                <td>
                  <span v-if="!editMode">
                    {{ pedido.descripcion_estado_pago }}
                  </span>
                  <div v-else class="form-field select">
                    <div class="select-field">
                      <select name="pagada" id="pagada" v-model="form.pagada">
                        <option value="0">Pendiente</option>
                        <option value="1">Pagada</option>
                      </select>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-if="pedido != null" class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <h5>Movimientos del cliente</h5>
          <button
            v-if="pedidoId != null && editMode"
            type="button"
            @click="agregarNotaDebitoCredito"
            class="btn-success"
          >
            <i class="fa fa-plus"></i>
          </button>
        </div>
        <div class="table-responsive">
          <table>
            <thead>
              <tr>
                <th>Tipo</th>
                <!-- <th># Doc.</th> -->
                <th>Fecha</th>
                <!-- <th>Cod. Barra</th> -->
                <th>Ítem</th>
                <!-- <th>Cantidad</th>
                <th>Precio</th> -->
                <th>Debe</th>
                <th>Haber</th>
                <th>Ruta</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>(+) Venta</strong>
                </td>
                <!-- <td></td> -->
                <td>
                  {{ pedido.fecha }}
                </td>
                <!-- <td></td> -->
                <td></td>
                <!-- <td></td>
                <td></td> -->
                <td>
                  {{ moneyFormat(total) }}
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr v-for="(item, index) in movimientos" :key="index">
                <th :tooltip="item.numero_documento" scope="row">
                  {{ (item.total < 0)?'(-)':'(+)' }} {{ item.tipo }}
                </th>
                <!-- <td>
                  {{ item.numero_documento }}
                </td> -->
                <td>
                  {{ item.fecha }}
                </td>
                <!-- <td>
                  {{ item.codigo_barra }}
                </td> -->
                <td :tooltip="item.codigo_barra">
                  {{ item.descripcion_item }}{{ item.cantidad != null?' - ' + decimalFormat(item.cantidad):'' }}{{ item.precio != null?' - ' + moneyFormat(item.precio):'' }}
                </td>
                <!-- <td>
                  {{ decimalFormat(item.cantidad) }}
                </td>
                <td>
                  {{ moneyFormat(item.precio) }}
                </td> -->
                <td>
                  <strong v-if="item.total > 0">{{ moneyFormat(item.total) }}</strong>
                </td>
                <td>
                    <strong v-if="item.total < 0">{{ moneyFormat(Math.abs(item.total)) }}</strong>
                </td>
                <td>
                  {{ item.ruta }}
                </td>
                <td v-if="item.id">
                  <button
                    type="button"
                    @click="eliminarNotaDebitoCredito(item.id)"
                    class="btn-danger"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
                <td v-else></td>
              </tr>
            </tbody>
            <tfoot>
              <th style="font-size: 18px;" colspan="3" scope="row">
                Saldo final
              </th>
              <td style="font-size: 18px;">
                <strong>{{ moneyFormat(totalDebe, 2) }}</strong>
              </td>
              <td style="font-size: 18px;">
                <strong>{{ moneyFormat(totalHaber, 2) }}</strong>
              </td>
              <td style="font-size: 18px;">
                <strong>{{ moneyFormat(parseFloat(totalDebe) - parseFloat(totalHaber), 2)/*moneyFormat(pedido.saldo_total, 2)*/ }}</strong>
              </td>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="col-xs-12">
        <h5>Ítems de la venta</h5>
        <div class="table-responsive">
          <table>
            <thead>
              <tr>
                <!-- <th>Cod. Barra</th> -->
                <th>Ítem</th>
                <th>Cantidad</th>
                <th>Precio</th>
                <th>Total</th>
                <th>Pendientes</th>
                <th>
                  <button
                    v-show="editMode"
                    type="button"
                    @click="agregarItem"
                    class="btn-success"
                  >
                    <i class="fa fa-plus"></i>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in form.items" :key="index">
                <!-- <td>
                  {{ item.codigo_barra != null?item.codigo_barra:item.item.codigo_barra }}
                </td> -->
                <td :tooltip="item.codigo_barra">
                  {{ item.item.descripcion }}
                </td>
                <td>
                  {{ decimalFormat(item.cantidad) }}
                </td>
                <td>
                  {{ moneyFormat(item.precio) }}
                </td>
                <td>
                  {{ moneyFormat(item.total) }}
                </td>
                <td>
                  {{ item.pendiente_verificacion === "S" ? "Sí" : "No" }}
                </td>
                <td>
                  <button
                    v-show="editMode"
                    type="button"
                    @click="editarItem(index)"
                    class="btn-info btn--text"
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                  <button
                    v-show="editMode"
                    type="button"
                    @click="eliminarItem(index)"
                    class="btn-danger btn--text"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
            <!-- <tfoot>
              <tr>
                <th scope="row">Totales</th>
                <td>
                  {{ decimalFormat(cantidadesTotales) }}
                </td>
                <td>
                  <span v-if="!editMode">
                    <strong># Pagos:</strong> {{ form.numero_pagos }}
                  </span>
                  <div v-else class="form-field">
                    <input-field
                      id="numero_pagos"
                      v-model="form.numero_pagos"
                      placeholder="###"
                      readonly
                    >
                      <span># Pagos</span>
                      <span
                        v-if="errores.numero_pagos"
                        class="helper-text text-danger"
                        slot="helper"
                      >
                        <strong>{{ errores.numero_pagos[0] }}</strong>
                      </span>
                    </input-field>
                  </div>
                </td>
                <td>
                  {{ moneyFormat(totalFinal) }}
                </td>
                <td colspan="2">
                  <span
                    ><strong>V. Pagos:</strong>
                    {{ moneyFormat(form.valor_pagos) }}
                  </span>
                </td>
              </tr>
            </tfoot> -->
          </table>
        </div>
      </div>
      
    </div>
    <div class="modal-buttons">
      <button
        v-show="editMode"
        type="button"
        @click="actualizar"
        class="btn-success"
      >
        <i class="fa fa-save"></i><span>Actualizar</span>
      </button>
      <button
        v-show="editMode"
        class="btn-warning btn--text"
        type="button"
        @click="cancelarEdicion"
      >
        <i class="fa fa-ban"></i>Cancelar edición
      </button>
      <button @click="$emit('cerrar')" class="btn-danger btn--text">
        <i class="fa fa-ban"></i><span>Cerrar</span>
      </button>
    </div>
    <modal
      name="itemPedido"
      adaptive
      reset
      resizable
      scrollable
      width="60%"
      :clickToClose="false"
      height="auto"
    >
      <item-pedido
        @input="inputItem"
        @cancelar="cancelarEdicionItem"
        v-model="selectedItem"
      ></item-pedido>
    </modal>
    <modal
      name="galeriaPedidos"
      height="auto"
      width="70%"
      scrollable
      adaptive
      reset
      resizable
    >
      <galeria-pedidos @cerrar="cerrar" v-model="pedido"></galeria-pedidos>
    </modal>
    <modal
      name="abonosPedido"
      width="65%"
      height="auto"
      reset
      resizable
      scrollable
      adaptive
      :clickToClose="false"
    >
      <abonos-pedido
        :puedeRegistrarAbonos="puedeRegistrarAbonos"
        :puedeEditarAbonos="puedeEditarAbonos"
        :puedeAnularAbonos="puedeAnularAbonos"
        :pedidoId="pedidoId"
        @cerrar="cerrarAbonosPedido"
      ></abonos-pedido>
    </modal>
    <modal 
      v-if="pedido != null" 
      name="informacionCliente" 
      height="auto" 
      width="60%" 
      scrollable 
      reset 
      adaptive 
      resizable
    >
      <informacion-cliente 
        @cerrar="$modal.hide('informacionCliente')" 
        v-model="pedido.cliente"
      ></informacion-cliente>
    </modal>
    <modal 
      name="comentariosVenta" 
      height="auto" 
      width="60%" 
      scrollable 
      reset 
      adaptive 
      resizable
    >
      <comentarios-venta 
        @cerrar="cerrarComentariosVenta" 
        :ventaId="pedidoId"
      ></comentarios-venta>
    </modal>
    <modal
      name="notaDebitoCredito"
      heigth="auto"
      width="60%"
      reset 
      adaptive
    >
      <nota-debito-credito
        @cerrar="cerrarNotaDebitoCredito"
        @guardar="guardarNotaDebitoCredito"
        :pedidoId="pedidoId"
      ></nota-debito-credito>
    </modal>
    <modal
      name="editarCoordenadas"
      heigth="auto"
      width="60%"
      reset 
      adaptive
    >
      <editar-coordenadas
        @cancelar="$modal.hide('editarCoordenadas')"
        @updated="updatedCoordenadas"
        :pedidoId="pedidoId"
        :latitud="pedido != null?pedido.latitud_venta:''"
        :longitud="pedido != null?pedido.longitud_venta:''"
      ></editar-coordenadas>
    </modal>
  </div>
</template>

<script>
import EditarCoordenadas from './EditarCoordenadas.vue';
import ComentariosVenta from "./ComentariosVenta.vue";
import ItemPedido from "./ItemPedido.vue";
import GaleriaPedidos from "./GaleriaPedidos.vue";
import AbonosPedido from "./AbonosPedido.vue";
import InformacionCliente from "./InformacionCliente.vue";
export default {
  computed: {
    totalDebe: function () {
      let total = this.total;
      for (let i = 0; i < this.movimientos.length; i++) {
        if(this.movimientos[i].total > 0)
          total += parseFloat(this.movimientos[i].total); 
      }
      return total;
    },
    totalHaber: function () {
      let total = 0;
      for (let i = 0; i < this.movimientos.length; i++) {
        if(this.movimientos[i].total < 0)
          total += parseFloat(this.movimientos[i].total); 
      }
      return Math.abs(total);
    },
    valor_pagos: function () {
      let valorPagos = 0;
      // let numero_pagos = parseInt(this.form.numero_pagos);
      // if (numero_pagos > 0) {
      //   valorPagos = round(this.total / numero_pagos, precision);
      // }
      // this.form.valor_pagos = valorPagos;
      return valorPagos;
    },
    totalFinal: function () {
      return this.total + this.totalAumentados + this.totalCambiados - this.totalDevueltos;
    },
    totalAumentados: function () {
      let totalAumentados = 0;
      for (let i = 0; i < this.itemsAumentados.length; i++) {
        totalAumentados += parseFloat(this.itemsAumentados[i].total);
      }
      return totalAumentados;
    },
    totalDevueltos: function () {
      let totalDevueltos = 0;
      for (let i = 0; i < this.itemsDevueltos.length; i++) {
        totalDevueltos += parseFloat(this.itemsDevueltos[i].total);
      }
      return totalDevueltos;
    },
    totalCambiados: function () {
      let totalCambiados = 0;
      for (let i = 0; i < this.itemsCambiados.length; i++) {
        totalCambiados += parseFloat(this.itemsCambiados[i].total) * (this.itemsCambiados[i].insa === 'IN'?1:-1);
      }
      return totalCambiados;
    },
    total: function () {
      let total = 0;
      for (let i = 0; i < this.form.items.length; i++) {
        let valorTotal = parseFloat(this.form.items[i].total);
        if (isNaN(valorTotal)) valorTotal = 0;
        total += valorTotal;
      }
      return total;
    },
    cantidadesTotales: function () {
      let cantidadesTotales = 0;
      for (let i = 0; i < this.form.items.length; i++) {
        let cantidad = parseFloat(this.form.items[i].cantidad);
        if (isNaN(cantidad)) cantidad = 0;
        cantidadesTotales += cantidad;
      }
      for (let i = 0; i < this.itemsAumentados.length; i++) {
        let cantidad = parseFloat(this.itemsAumentados[i].cantidad);
        if (isNaN(cantidad)) cantidad = 0;
        cantidadesTotales += cantidad;
      }
      for (let i = 0; i < this.itemsDevueltos.length; i++) {
        let cantidad = parseFloat(this.itemsDevueltos[i].cantidad);
        if (isNaN(cantidad)) cantidad = 0;
        cantidadesTotales -= cantidad;
      }
      for (let i = 0; i < this.itemsCambiados.length; i++) {
        let cantidad = parseFloat(this.itemsCambiados[i].cantidad);
        if (isNaN(cantidad)) cantidad = 0;
        if (this.itemsCambiados[i].insa === 'SA')
          cantidadesTotales -= cantidad;
        else 
          cantidadesTotales += cantidad;
      }
      return cantidadesTotales;
    },
  },
  components: {
    InformacionCliente,
    ItemPedido,
    GaleriaPedidos,
    AbonosPedido,
    ComentariosVenta,
    EditarCoordenadas
  },
  props: {
    cliente: {
      type: Object,
      required: false,
      default: function () {
        return null;
      }
    },
    puedeRegistrarAbonos: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeEditarAbonos: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeAnularAbonos: {
      type: Boolean,
      required: false,
      default: false,
    },
    puedeEditarPedido: {
      type: Boolean,
      required: false,
      default: false,
    },
    pedidoId: {
      type: String,
      required: false,
      default: "",
    },
  },
  data: function () {
    return {
      verAuditoria: false,
      premios: [],
      selectedRuta: null,
      rutas: [],
      pedido: null,
      decimalFormat: decimalFormat,
      moneyFormat: moneyFormat,
      editMode: false,
      clientes: [],
      selectedCliente: null,
      errores: {},
      selectedItem: null,
      selectedIndex: -1,
      nuevoItem: false,
      form: null,
      vendedores: [],
      selectedVendedor: null,
      selectedSupervisor: null,
      supervisores: [],
      selectedVerificador: null,
      verificadores: [],
      recaudadores: [],
      selectedRecaudador: null,
      itemsAumentados: [],
      itemsDevueltos: [],
      itemsCambiados: [],
      movimientos: []
    };
  },
  methods: {
    updatedCoordenadas: function () {
      this.cargarPedido();
      this.$modal.hide('editarCoordenadas');
    },
    agregarNotaDebitoCredito: function () {
      this.$modal.show("notaDebitoCredito");
    },
    cerrarNotaDebitoCredito: function () {
      this.$modal.hide("notaDebitoCredito");
    },
    cerrarComentariosVenta: function () {
      this.$modal.hide("comentariosVenta");
    },
    verComentarios: function () {
      this.$modal.show("comentariosVenta");
    },
    verInfoCliente: function () {
      this.$modal.show("informacionCliente");
    },
    guardarNotaDebitoCredito: function (datos) {
      let urlApi = url + '/pedido/guardar-nota/debito_credito';
      datos.pedido_id = this.pedidoId;
      axios
        .post(urlApi, datos)
        .then(response => {
          let tipo = datos.tipoDocumento == 'ND' ? 'NOTA DÉBITO' : 'NOTA CRÉDITO';
          let total = datos.tipoDocumento == 'ND' ? parseFloat(datos.valor) : (parseFloat(datos.valor) * -1);
          this.movimientos.push({
            id: response.data.id,
            tipo: tipo,
            numero_documento: null,
            fecha: datos.fecha,
            codigo_barra: null,
            descripcion_item: datos.motivo_descripcion,
            cantidad: null,
            precio: null,
            total: total,
            ruta: datos.ruta,
          });
          swal('Realizado', `La ${tipo} ha sido guardada`, 'success');
          this.$modal.hide("notaDebitoCredito");
        })
        .catch(error => {
          swal('Error', 'No se pudo guardar el documento', 'error');
        });
    },
    eliminarNotaDebitoCredito: function(id) {
      swal({
          title: "¿Desea eliminar el registro?",
          text: "",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.value) {
            let index = -1;
            for(let i=0; i < this.movimientos.length; i++){
              if(this.movimientos[i].id == id){
                index = id;
                break;
              }
            }
            let urlApi = url + '/pedido/eliminar-nota/debito_credito/' + id;
            axios
              .get(urlApi)
              .then(response => {
                swal('Realizado', `El documento ha sido eliminado`, 'success');
                this.movimientos.splice(index, 1);
              })
              .catch(error => {
                swal('Error', 'No se pudo eliminar el documento', 'error');
              });
          }
        });      
    },
    verDireccionVenta: function () {
      window.open(
        "https://maps.google.com?q=" +
          this.pedido.latitud_venta +
          "," +
          this.pedido.longitud_venta,
        "_blank"
      );
    },
    verDireccionCliente: function () {
      window.open(
        "https://maps.google.com?q=" +
          this.pedido.cliente.coordenadas_cliente.coordinates[1] +
          "," +
          this.pedido.cliente.coordenadas_cliente.coordinates[0],
        "_blank"
      );
    },
    onSearchRutas: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.rutas = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/rutas?search=" + search, true);
      xmlhttp.send();
    },
    inputRuta: function () {
      if (this.selectedRuta != null) this.form.ruta_id = this.selectedRuta.id;
      else this.form.ruta_id = "";
    },
    editarAbonos: function () {
      this.$modal.show("abonosPedido");
    },
    cerrarAbonosPedido: function () {
      this.$modal.hide("abonosPedido");
    },
    searchRecaudadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=R&search=" + search,
        true
      );
      xmlhttp.send();
    },
    inputRecaudador: function () {
      if (this.selectedRecaudador != null)
        this.form.recaudador_id = this.selectedRecaudador.id;
      else this.form.recaudador_id = "";
    },
    searchVerificadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.verificadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/verificadores?tipo=V&search=" + search,
        true
      );
      xmlhttp.send();
    },
    inputVerificador: function () {
      if (this.selectedVerificador != null)
        this.form.verificador_id = this.selectedVerificador.id;
      else this.form.verificador_id = "";
    },
    searchSupervisores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.supervisores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=S&search=" + search,
        true
      );
      xmlhttp.send();
    },
    inputSupervisor: function () {
      if (this.selectedSupervisor != null)
        this.form.supervisor_id = this.selectedSupervisor.id;
      else this.form.supervisor_id = "";
    },
    inputVendedor: function () {
      if (this.selectedVendedor != null)
        this.form.vendedor_id = this.selectedVendedor.id;
      else this.form.vendedor_id = "";
    },
    onSearchVendedores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.vendedores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/vendedores?search=" + search, true);
      xmlhttp.send();
    },
    onSearchClientes: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.clientes = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/clientes?search=" + search, true);
      xmlhttp.send();
    },
    inputCliente: function () {
      if (this.selectedCliente != null)
        this.form.cliente_id = this.selectedCliente.id;
      else this.form.cliente_id = "";
    },
    cerrar: function () {
      this.$modal.hide("galeriaPedidos");
    },
    verGaleria: function () {
      this.$modal.show("galeriaPedidos");
    },
    eliminarItem: function (index) {
      this.form.items.splice(index, 1);
    },
    inputItem: function (item) {
      this.form.items.splice(this.selectedIndex, 1, item);
      this.$modal.hide("itemPedido");
    },
    cancelarEdicionItem: function () {
      if (this.nuevoItem) {
        this.form.items.splice(this.selectedIndex, 1);
        this.nuevoItem = false;
      }
      this.$modal.hide("itemPedido");
    },
    editarItem: function (index) {
      this.selectedIndex = index;
      this.selectedItem = this.form.items[index];
      this.nuevoItem = false;
      this.$modal.show("itemPedido");
    },
    agregarItem: function () {
      this.selectedIndex =
        this.form.items.push({
          item_id: "",
          item: {
            id: "",
            nombre: "",
          },
          cantidad: 1,
          precio: 0,
          total: 0,
          codigo_barra: ''
        }) - 1;
      this.selectedItem = this.form.items[this.selectedIndex];
      this.nuevoItem = true;
      this.$modal.show("itemPedido");
    },
    actualizar: function () {
      this.errores = {};
      if (this.form.items.length == 0) {
        swal("Debe agregar al menos un ítem en el pedido.", "Aviso", "warning");
      } else {
        swal({
          title: "¿Desea editar los datos del pedido?",
          text: "Se almacenará los datos del pedido",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Sí",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.value) {
            axios
              .post(url + "/logistica/pedido/" + this.pedidoId, {
                fecha: this.form.fecha,
                cliente_id: this.form.cliente_id,
                observacion: this.form.observacion,
                items: this.form.items,
                _method: "PUT",
                observacion_modificacion: this.form.observacion_modificacion,
                numero_pagos: this.form.numero_pagos,
                valor_pagos: this.form.valor_pagos,
                vendedor_id: this.form.vendedor_id,
                dia_cobro: this.form.dia_cobro,
                supervisor_id: this.form.supervisor_id,
                recaudador_id: this.form.recaudador_id,
                verificador_id: this.form.verificador_id,
                tiene_premio: this.form.tiene_premio,
                ruta_id: this.form.ruta_id,
                pagada: this.form.pagada
              })
              .then(() => {
                swal(
                  "Los datos del pedido fueron actualizados.",
                  "Realizado",
                  "success"
                );
                this.cargarPedido();
                this.$emit("actualizado");
              })
              .catch(({ response }) => {
                if (response.status === 422) {
                  this.errores = response.data.errors;
                  swal(
                    "Hay errores en el formulario, intente nuevamente.",
                    "Aviso",
                    "warning"
                  );
                } else
                  swal("Hubo un error, intente nuevamente.", "Error", "error");
              });
          }
        });
      }
    },
    cancelarEdicion: function () {
      this.form = JSON.parse(JSON.stringify(this.pedido));
      this.selectedCliente = this.form.cliente;
      this.selectedVendedor = this.form.vendedor;
      this.selectedRecaudador = this.form.recaudador;
      this.selectedVerificador = this.form.verificador;
      this.selectedSupervisor = this.form.supervisor;
      this.editMode = false;
    },
    editar: function () {
      this.form = JSON.parse(JSON.stringify(this.pedido));
      this.editMode = true;
    },
    imprimirKardex: function () {
      window.open(url + "/pedido-kardex/" + this.pedidoId, "_blank");
    },
    imprimir: function () {
      window.open(url + "/pedido/" + this.pedidoId, "_blank");
    },
    cargarPedido: function () {
      axios
        .get(url + "/logistica/pedido/" + this.pedidoId)
        .then(({ data }) => {
          this.pedido = data;
          this.form = JSON.parse(JSON.stringify(this.pedido));
          this.selectedCliente = this.pedido.cliente;
          this.selectedVendedor = this.pedido.vendedor;
          this.selectedSupervisor = this.pedido.supervisor;
          this.selectedRecaudador = this.pedido.recaudador;
          this.selectedVerificador = this.pedido.verificador;
          this.selectedRuta = this.pedido.ruta;
          this.itemsAumentados.splice(0, this.itemsAumentados.length);
          this.itemsDevueltos.splice(0, this.itemsDevueltos.length);
          this.itemsCambiados.splice(0, this.itemsCambiados.length);
          this.premios.splice(0, this.premios.length);
          for (let i = 0; i < this.pedido.premios.length; i++) {
            for (
              let j = 0;
              j < this.pedido.premios[i].items.length;
              j++
            ) {
              this.premios.push({
                fecha: this.pedido.premios[i].fecha_premio,
                numero_documento:
                  this.pedido.premios[i].numero_documento,
                cantidad: this.pedido.premios[i].items[j].cantidad,
                codigo_barra:
                  this.pedido.premios[i].items[j].codigo_barra != null?this.pedido.premios[i].items[j].codigo_barra:this.pedido.premios[i].items[j].item.codigo_barra,
                descripcion_item:
                  this.pedido.premios[i].items[j].item.descripcion,
                ruta: this.pedido.premios[i].recaudacion != null?this.pedido.premios[i].recaudacion.ruta.nombre:''
              });
            }
          }
          for (let i = 0; i < this.pedido.aumentos_venta.length; i++) {
            for (
              let j = 0;
              j < this.pedido.aumentos_venta[i].items.length;
              j++
            ) {
              this.itemsAumentados.push({
                fecha: this.pedido.aumentos_venta[i].fecha,
                numero_documento_aumento:
                  this.pedido.aumentos_venta[i].numero_documento,
                cantidad: this.pedido.aumentos_venta[i].items[j].cantidad,
                precio: this.pedido.aumentos_venta[i].items[j].precio,
                total: this.pedido.aumentos_venta[i].items[j].total,
                codigo_barra:
                  this.pedido.aumentos_venta[i].items[j].codigo_barra != null?this.pedido.aumentos_venta[i].items[j].codigo_barra:this.pedido.aumentos_venta[i].items[j].item.codigo_barra,
                descripcion_item:
                  this.pedido.aumentos_venta[i].items[j].item.descripcion,
                ruta: this.pedido.aumentos_venta[i].recaudacion != null?this.pedido.aumentos_venta[i].recaudacion.ruta.nombre:''
              });
            }
          }
          for (let i = 0; i < this.pedido.devoluciones.length; i++) {
            for (
              let j = 0;
              j < this.pedido.devoluciones[i].items.length;
              j++
            ) {
              this.itemsDevueltos.push({
                fecha: this.pedido.devoluciones[i].fecha_devolucion,
                numero_documento:
                  this.pedido.devoluciones[i].numero_documento,
                cantidad: this.pedido.devoluciones[i].items[j].cantidad,
                precio: this.pedido.devoluciones[i].items[j].precio,
                total: this.pedido.devoluciones[i].items[j].total,
                codigo_barra:
                  this.pedido.devoluciones[i].items[j].codigo_barra != null?this.pedido.devoluciones[i].items[j].codigo_barra:this.pedido.devoluciones[i].items[j].item.codigo_barra,
                descripcion_item:
                  this.pedido.devoluciones[i].items[j].item.descripcion,
                ruta: this.pedido.devoluciones[i].recaudacion != null?this.pedido.devoluciones[i].recaudacion.ruta.nombre:''
              });
            }
          }
          for (let i = 0; i < this.pedido.cambios.length; i++) {
            for (
              let j = 0;
              j < this.pedido.cambios[i].items.length;
              j++
            ) {
              this.itemsCambiados.push({
                fecha: this.pedido.cambios[i].fecha_cambio,
                numero_documento:
                  this.pedido.cambios[i].numero_documento,
                cantidad: this.pedido.cambios[i].items[j].cantidad,
                precio: this.pedido.cambios[i].items[j].precio,
                total: this.pedido.cambios[i].items[j].total,
                codigo_barra:
                  this.pedido.cambios[i].items[j].codigo_barra != null?this.pedido.cambios[i].items[j].codigo_barra:this.pedido.cambios[i].items[j].item.codigo_barra,
                descripcion_item:
                  this.pedido.cambios[i].items[j].item.descripcion,
                  insa:
                  this.pedido.cambios[i].items[j].insa,
                ruta: this.pedido.cambios[i].recaudacion != null?this.pedido.cambios[i].recaudacion.ruta.nombre:''
              });
            }
          }
          this.movimientos.splice(0, this.movimientos.length);
          for(let i = 0; i < this.premios.length; i++) {
            this.movimientos.push({
              id: null,
              tipo: 'Premio',
              numero_documento: this.premios[i].numero_documento,
              fecha: this.premios[i].fecha,
              codigo_barra: this.premios[i].codigo_barra,
              descripcion_item: this.premios[i].descripcion_item,
              cantidad: this.premios[i].cantidad,
              precio: null,
              total: null,
              ruta: this.premios[i].ruta
            });
          }
          for(let i = 0; i < this.itemsAumentados.length; i++) {
            this.movimientos.push({
              id: null,
              tipo: 'Aumento',
              numero_documento: this.itemsAumentados[i].numero_documento_aumento,
              fecha: this.itemsAumentados[i].fecha,
              codigo_barra: this.itemsAumentados[i].codigo_barra,
              descripcion_item: this.itemsAumentados[i].descripcion_item,
              cantidad: this.itemsAumentados[i].cantidad,
              precio: this.itemsAumentados[i].precio,
              total: this.itemsAumentados[i].total,
              ruta: this.itemsAumentados[i].ruta
            });
          }
          for(let i = 0; i < this.itemsDevueltos.length; i++) {
            this.movimientos.push({
              id: null,
              tipo: 'Devolución',
              numero_documento: this.itemsDevueltos[i].numero_documento,
              fecha: this.itemsDevueltos[i].fecha,
              codigo_barra: this.itemsDevueltos[i].codigo_barra,
              descripcion_item: this.itemsDevueltos[i].descripcion_item,
              cantidad: this.itemsDevueltos[i].cantidad,
              precio: this.itemsDevueltos[i].precio,
              total: parseFloat(this.itemsDevueltos[i].total) * -1,
              ruta: this.itemsDevueltos[i].ruta
            });
          }
          for(let i = 0; i < this.itemsCambiados.length; i++) {
            this.movimientos.push({
              id: null,
              tipo: this.itemsCambiados[i].insa + '-' + 'Cambio',
              numero_documento: this.itemsCambiados[i].numero_documento,
              fecha: this.itemsCambiados[i].fecha,
              codigo_barra: this.itemsCambiados[i].codigo_barra,
              descripcion_item: this.itemsCambiados[i].descripcion_item,
              cantidad: this.itemsCambiados[i].cantidad,
              precio: this.itemsCambiados[i].precio,
              total: parseFloat(this.itemsCambiados[i].total) * (this.itemsCambiados[i].insa === 'IN'?-1:1),
              ruta: this.itemsCambiados[i].ruta
            });
          }
          let abonos = this.pedido.abonos;
          for (let i = 0; i < abonos.length; i++) {
            this.movimientos.push({
              id: null,id: null,
              tipo: 'Abono',
              numero_documento: abonos[i].numero_secuencia,
              fecha: abonos[i].fecha_abono,
              codigo_barra: null,
              descripcion_item: null,
              cantidad: null,
              precio: null,
              total: parseFloat(abonos[i].valor_abono) * -1,
              ruta: abonos[i].ruta
            });
          }
          //Agregando notas de débito y crédito
          let documentos = this.pedido.documentos;
          for (let i = 0; i < documentos.length; i++) {
            let tipo = documentos[i].tipo_documento == 'ND' ? 'NOTA DÉBITO' : 'NOTA CRÉDITO';
            let total = documentos[i].tipo_documento == 'ND' ? parseFloat(documentos[i].valor) : (parseFloat(documentos[i].valor) * -1);
            this.movimientos.push({
              id: documentos[i].id,
              tipo: tipo,
              numero_documento: null,
              fecha: documentos[i].fecha,
              codigo_barra: null,
              descripcion_item: documentos[i].motivo != null
                ? documentos[i].motivo.descripcion : '',
              cantidad: null,
              precio: null,
              total: total,
              ruta: documentos[i].ruta != null?documentos[i].ruta.nombre:''
            });
          }         
          this.movimientos = _.sortBy(this.movimientos, o => new Date(o.fecha), ['desc']);
        })
        .catch((error) => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
  },
  mounted: function () {
    this.cargarPedido();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/InformacionPedido.vue